import { render, staticRenderFns } from "./PassedInsurance.vue?vue&type=template&id=0089726c&"
import script from "./PassedInsurance.vue?vue&type=script&lang=js&"
export * from "./PassedInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PassedInsurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports